import Cookies from 'js-cookie';
import { axios } from 'lib/axios';

export const verifySMSOTP = (data) => {
  const token = Cookies.get('token');
  return axios.patch('/user/sms/verifyCode', data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
